import { Menu } from './menu.model';

export const menuItems = [
    // id, title, routerLink, icon, codigo
    new Menu (20, 'Inicio', '/app/inicio', 'equalizer', 'MENU0023'),
    new Menu (1, 'Punto de Venta', '/app/venta/N', 'add_shopping_cart', 'MENU0001'),
    new Menu (2, 'Histórico-Ventas', '/app/venta', 'shopping_basket', 'MENU0002'),
    new Menu (2, 'Histórico-Compras', '/app/compra/:parametro', 'shopping_basket', 'MENU0018'),
    new Menu (3, 'Productos', '/app/product', 'book', 'MENU0003'),
    new Menu (4, 'Clientes', '/app/clientes-sae', 'person_outline', 'MENU0004'),
    new Menu (4, 'Proveedores', '/app/proveedores-sae/:parametro', 'person_outline', 'MENU0017'),
    new Menu (16, 'Cuentas por cobrar', '/app/cuentasCobrar', 'person_outline', 'MENU0016'),
    new Menu (5, 'Listas de Precios', '/app/lista-precios', 'featured_play_list', 'MENU0005'),
    new Menu (17, 'Listas de Precios-Compra', '/app/lista-precios-Compra/:parametro', 'featured_play_list', 'MENU0025'),
    // new Menu (6, 'Retiros de Efectivo', '/app/retiros', 'local_atm', 'MENU0006'),
    // new Menu (7, 'Corte de Caja', '/app/corte-caja', 'dvr', 'MENU0007'),
    // new Menu (8, 'Facturas', '/app/factura/', 'list_alt', 'MENU0008'),
    // new Menu (9, 'Recepción de Pagos', '/app/reciboPago', 'payments', 'MENU0009'),
    // new Menu (10, 'Nota de Crédito', '/app/notaCredito', 'note', 'MENU0010'),
    // new Menu (15, 'Nota de Cargo', '/app/notaCargo', 'input', 'MENU0015'),
    // new Menu (11, 'Entradas', '/app/entrada', 'arrow_downward', 'MENU0011'),
    // new Menu (12, 'Inventario', '/app/inventario', 'assignment', 'MENU0012'),
    // new Menu (13, 'Salidas', '/app/salida', 'arrow_upward', 'MENU0013'),
    //new Menu (14, 'Conversión de Materiales', '/app/materiales', 'arrow_upward', 'MENU0014'),
    new Menu (15, 'Concentrado Pagos', '/app/concentrado-pagos', 'arrow_upward', 'MENU0014'),
    // new Menu (18, 'Dirección Compañia', '/app/dirección-compañia', 'home', 'MENU0013'),
    // new Menu (16, 'Chofer', '/app/chofer', 'person', 'MENU0013'),
    // new Menu (17, 'Vehiculo', '/app/vehiculo', 'directions_car', 'MENU0013'),
   

]
export const menuCatalogo = [
    new Menu (16, 'Chofer', '/app/chofer', 'person', 'MENU0019'),
    new Menu (17, 'Vehiculo', '/app/vehiculo', 'directions_car', 'MENU0020'),
    new Menu (18, 'Dirección Compañia', '/app/dirección-compañia', 'home', 'MENU0021'),
    new Menu (18, 'Producto Sat', '/app/itemSat', 'format_list_bulleted', 'MENU0026'),
    new Menu (18, 'Cuenta Bancaria', '/app/cuentaBancaria', 'account_balance', 'MENU0027'),
    new Menu (18, 'Usuario', '/app/usuarioSAE', 'person_add', 'MENU0033'),
]
export const menuCaja = [
    new Menu (6, 'Retiros de Efectivo', '/app/retiros', 'local_atm', 'MENU0006'),
    new Menu (7, 'Corte de Caja', '/app/corte-caja', 'dvr', 'MENU0007'),
]
export const menuFacturacion = [
    new Menu (8, 'Facturas', '/app/factura/', 'list_alt', 'MENU0008'),
    new Menu (9, 'Recepción de Pagos', '/app/reciboPago', 'payments', 'MENU0009'),
    new Menu (10, 'Nota de Crédito', '/app/notaCredito', 'note', 'MENU0010'),
    new Menu (15, 'Nota de Cargo', '/app/notaCargo', 'input', 'MENU0015'),
    new Menu (34, 'Cuentas por Cobrar (Facturas)', '/app/cuentasCobrarFactura', 'request_quote', 'MENU0034'),
]
export const menuInventarios = [
    new Menu (11, 'Entradas', '/app/entrada', 'arrow_downward', 'MENU0011'),
    new Menu (12, 'Inventario', '/app/inventario', 'assignment', 'MENU0012'),
    new Menu (13, 'Salidas', '/app/salida', 'arrow_upward', 'MENU0013'),
]

export const menuContabilidad = [
    new Menu (20, 'Cuenta', '/app/cuentas', 'credit_card_gear', 'MENU0023'),
    new Menu (21, 'Polizas', '/app/polizas', 'receipt_long', 'MENU0022'),
    new Menu (19, 'Reporte Auxiliar de Cuenta', '/app/reporteAuxiliarCuenta', 'account_balance_wallet', 'MENU0024'),
    new Menu (19, 'Balanza', '/app/balanzaComprobacion', 'account_balance', 'MENU0028'),
    new Menu (19, 'Balance General', '/app/balanceGeneral', 'account_balance', 'MENU0029'),
    new Menu (19, 'Estado de Resultados', '/app/estadoResultados', 'account_balance', 'MENU0030'),
    new Menu (19, 'DIOT', '/app/diot', 'account_balance', 'MENU0031'),
    new Menu (18, 'Conciliación Bancaria', '/app/conciliacionBancaria', 'account_balance', 'MENU0032'),
]
export const menuInico = []


// WEBPACK FOOTER //
// ./src/app/layout/sidenav/menu/menu.ts